import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';

export const useZodForm = ({ getSchema, defaultValues }) => {
  const { t } = useTranslation();
  const resolver = zodResolver(getSchema({ t }));

  return useForm({
    resolver,
    mode: 'onTouched',
    defaultValues,
  });
};
